import React from 'react';
import { StarIcon } from 'lucide-react';
import { branches } from '../data/homepage';
export function BranchBar() {
  return <section aria-labelledby="branches-heading" className="bg-navy-deep text-paper" data-id="element-2" data-mp="3m1j9b3kwzwb0">
      <FlagStripe data-id="element-3" data-mp="3qyt654amva8v" />
      <div className="mx-auto max-w-7xl px-6 py-10 md:px-10 md:py-12" data-id="element-4" data-mp="3qy9ozpst4pvw">
        <h2 id="branches-heading" className="text-center text-sm font-semibold tracking-[0.2em] text-gold" data-id="element-5" data-mp="3vz7ekng5cm7f">
          PROUDLY SERVING VETERANS OF EVERY BRANCH
        </h2>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 md:gap-x-7" data-id="element-6" data-mp="8tg9hrjz4j0n">
          {branches.map((branch, i) => <li key={branch} className="flex items-center gap-5 md:gap-7" data-id="element-7" data-mp="dn15xf5x54xq" data-mpi={i}>
              {i > 0 && <StarIcon aria-hidden="true" className="h-3 w-3 fill-honor text-honor" strokeWidth={1} data-id="element-8" data-mp="ij9hkikwqg05" />}
              <span className="whitespace-nowrap font-serif text-xl font-semibold md:text-2xl" data-id="element-9" data-mp="nkyts1jv8zpt">{branch}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}

/** Thin red, white, and blue stripe — a quiet flag reference. */
export function FlagStripe() {
  return <div aria-hidden="true" className="flex h-1.5 w-full flex-col" data-id="element-10" data-mp="qekzjoirt2ia">
      <span className="h-1/3 bg-honor" data-id="element-11" data-mp="lgb3lbp81xvm" />
      <span className="h-1/3 bg-paper" data-id="element-12" data-mp="lhcmg2chbonw" />
      <span className="h-1/3 bg-[#1F3F75]" data-id="element-13" data-mp="hfzijxsy5vjm" />
    </div>;
}